const groupReservation = {
    "list_view": "Lista nézet",
    "calendar_view": "Naptár nézet",
    "calendar_placeholder": "Naptár nézet hamarosan...",
    "request_comments": "Belső megjegyzések",
    "status": "Státusz",
    "filter_actual": "Aktuális",
    "filter_all": "Összes",
    "status_active": "Aktív",
    "status_inactive": "Inaktív",
    "tabs": {
        "relevant": "Aktuális ajánlatok",
        "excluded": "Kizárt ajánlatok",
        "own-offers": "Saját ajánlatok",
    },
     "not_visible_warning": "Szeretnél több csoportos ajánlatkérést?\nJelenj meg a reservours.com/csoportos-foglalas aloldalon!\nEngedélyezd most a beállítások/csoportos foglalás menüpontban!",   
    "offer_deadline": "Ajánlatadás határideje",
    "event_name": "Ajánlatkérő neve",
    "event_type": "Esemény jellege",
    "event_date": "Esemény dátuma",
    "event_duration": "Esemény időtartama",
    "guest_count": "Vendégek száma",
    "details": "Részletek",
    "not_interested": "Nem érdekel",
    "refresh": "Frissítés",
    "new_request": "Új ajánlatkérés létrehozása",
    "type_group": {
        "COMPANY": "Céges események",
        "FAMILY": "Családi események",
        "FRIENDS": "Baráti események"
    },
    "type": {
        "COMPANY_DINNER": "Céges vacsora",
        "COMPANY_PARTY": "Céges buli",
        "COMPANY_CHRISTMAS": "Céges karácsony / évzáró",
        "TEAM_BUILDING": "Csapatépítés",
        "COMPANY_DRINKING": "Céges sörözés",
        "FAREWELL_PARTY": "Búcsúbuli",
        "WEDDING": "Esküvő",
        "BIRTHDAY": "Születésnap",
        "ANNIVERSARY": "Évforduló",
        "FAMILY_EVENT": "Családi esemény",
        "CHRISTENING": "Keresztelő",
        "GRADUATION": "Ballagás",
        "CLASS_REUNION": "Osztálytalálkozó",
        "BACHELOR_PARTY": "Legénybúcsú / lánybúcsú",
        "FRIENDS_GATHERING": "Baráti összejövetel",
        "OTHER": "Egyéb"
    },
    "contact_method": {
        "EITHER": "Bármelyik",
        "PHONE": "Telefon",
        "EMAIL": "Email"
    },
    "source": {
        "FRONTEND": "Honlap",
        "EMBED": "Beágyazott",
        "ADMIN": "Admin",
        "PRIVATE_LINK": "Privát link"
    },
    "form_labels": {
        "date": "Dátum",
        "time": "Időpont",
        "duration": "Időtartam",
        "guest_count": "Létszám"
    },
    "form_section": {
        "basics": "Alapadatok",
        "event": "Rendezvény",
        "package": "Csomag ajánlása (opcionális)",
        "contact": "Kapcsolat és határidő",
        "description": "Rendezvény leírása"
    },
    "packages": {
        "title": "Ajánlható csomagok",
        "new": "Új csomag",
        "empty": "Még nincs csomag. Hozz létre egyet, hogy a vendégek választhassanak.",
        "no_image": "Nincs kép",
        "no_name": "Névtelen csomag",
        "preview_public": "Publikus előnézet",
        "activate": "Aktiválás",
        "archive": "Archiválás",
        "unarchive": "Vissza piszkozatba",
        "hard_delete": "Végleges törlés",
        "toggle_featured": "Kiemelés",
        "move_up": "Fel",
        "move_down": "Le",
        "order_label": "Sorrend",
        "price_suffix_per_person": "Ft/fő",
        "price_suffix_total": "Ft (fix)",
        "size_range": "{{min}}–{{max}} fő",
        "date_range": "{{from}} – {{to}}",
        "save_success": "Csomag mentve",
        "status_updated": "Állapot frissítve",
        "deleted": "Csomag törölve",
        "delete_conflict": "Nem törölhető, mert érkezett rá ajánlatkérés. Archiváld helyette.",
        "archive_confirm": "Biztosan archiválod ezt a csomagot? \"{{name}}\" – nem lesz többé választható a vendégek számára.",
        "hard_delete_confirm": "Biztosan végleg törlöd a \"{{name}}\" csomagot? Ha érkezett rá ajánlatkérés, csak archiválni lehet.",
        "selected_title": "A vendég által kiválasztott csomagok",
        "selected_snapshot_hint": "A vendég beküldésekor rögzített változat. A csomag későbbi módosítása ezt nem érinti.",
        "picker": {
            "label": "Csomagok",
            "hint": "Válaszd ki, mely csomagokat ajánlod a vendégnek.",
            "no_active": "Nincs elérhető aktív csomag.",
            "none": "Nincs csomag",
            "selected_summary": "{{count}} csomag kiválasztva",
            "no_selection_hint": "Nincs csomag hozzárendelve. Kattints a bővítéshez.",
            "edit": "Csomagok módosítása",
            "save": "Csomagok mentése",
            "saved": "Csomagok mentve",
            "reason": {
                "below_min": "Kevesebb a létszám a csomag minimumánál",
                "above_max": "Több a létszám a csomag maximumánál",
                "date_out": "A dátum kívül esik az érvényességen"
            }
        },
        "status": {
            "DRAFT": "Piszkozat",
            "ACTIVE": "Aktív",
            "ARCHIVED": "Archivált"
        },
        "status_filter": {
            "label": "Szűrés állapotra",
            "all": "Összes"
        },
        "form": {
            "title_new": "Új csomag létrehozása",
            "title_edit": "Csomag szerkesztése",
            "name_hu": "Név (magyar)",
            "name_en": "Név (angol)",
            "description_hu": "Leírás (magyar)",
            "description_en": "Leírás (angol)",
            "description_long_warning": "Nagyon hosszú leírás – a publikus oldalon \"Bővebben\" gomb mögé kerül.",
            "image": "Kép",
            "price_type": "Ár típusa",
            "price_per_person": "Per fő",
            "price_total": "Fix összeg",
            "price_per_person_label": "Ár (Ft/fő)",
            "price_total_label": "Fix ár (Ft)",
            "min_size": "Minimum létszám",
            "max_size": "Maximum létszám",
            "size_zero_hint": "0 = nincs korlát",
            "min_size_hint": "Ha a csomag min. létszáma nagyobb mint az étterem min. létszáma, a vendégnek felugrik a fő szám a csomag választásakor.",
            "has_availability": "Korlátozott érvényesség (csak egy adott időszakban választható)",
            "available_from": "Érvényes -tól",
            "available_to": "Érvényes -ig",
            "status": "Állapot",
            "display_order": "Sorrend",
            "is_featured": "Kiemelt csomag (a lista elején jelenik meg)"
        },
        "image": {
            "upload": "Kép feltöltése",
            "replace": "Kép cseréje",
            "remove": "Eltávolítás",
            "hint": "JPG, PNG vagy WEBP. Max 5 MB. Javasolt arány: 16:9 fekvő.",
            "invalid_type": "Csak JPG, PNG vagy WEBP kép engedélyezett.",
            "too_large": "A fájl mérete túl nagy (max 5 MB).",
            "pending_upload": "A kép mentéskor kerül feltöltésre.",
            "upload_failed": "A kép feltöltése nem sikerült."
        },
        "validation": {
            "name_hu_required": "A magyar név megadása kötelező.",
            "name_en_required": "Az angol név megadása kötelező.",
            "description_hu_required": "A magyar leírás megadása kötelező.",
            "description_en_required": "Az angol leírás megadása kötelező.",
            "price_required": "Adj meg egy 0-nál nagyobb árat.",
            "min_max_size": "A minimum létszám nem lehet nagyobb, mint a maximum.",
            "available_range": "Az érvényesség kezdete nem lehet a vége után.",
            "name_too_long": "A név legfeljebb 200 karakter lehet.",
            "image_url_too_long": "A kép URL túl hosszú."
        }
    },
    "request_status": "Ajánlatkérés állapota",
    "company_name": "Cég neve",
    "preferred_contact_method": "Preferált kapcsolatfelvétel",
    "is_separated": "Külön terem szükséges?",
    "offer_created_at": "Ajánlat létrehozva ekkor",
    "show_contacts": "Kattints ide az elérhetőségek megjelenítéséhez",
    "offer_notes": "Ajánlat szövege",
    "request_details": "Ajánlatkérés részletei",
    "your_offer_details": "Ajánlatod részletei",
    "send_offer": "Ajánlat elküldése",
    "contact_telephone": "Telefonszám",
    "contact_email": "Email cím",
    "event_time": "Esemény időpontja",
    "event_description": "Esemény leírása",
    "contact_phone": "Telefonszám",
    "hide_request": "Ajánlatkérés elrejtése",
    "exclude_request": "Biztos el szeretnéd rejteni ezt az ajánlatkérést a lista oldaladról?",
    "exclude_request_confirmation": 'Az elrejtett elemeket később még a lista oldalon lévő státusz szűrő -> "Elrejtett ajánlatok" bekapcsolásával vissza tudod állítani.',
    "notify_customer": "Értesítsük a vendéget a döntésről?",
    "notification_message": "Értesítés szövege",
    "clear_excluded_requests": "Összes kizárás feloldása",
    "clear_exclusion": "Kizárás feloldása",
    "offer_saved": "Az ajánlat sikeresen elküldésre került",
    "new_request_saved": "Az új ajánlatkérés sikeresen létrejött",
    "edit_offer": "Ajánlat szerkesztése",
    "offer_request_details": "Ajánlatkérés részletei",
    "save_and_send": "Mentés és újraküldés",
    "transform_to_reservation": "Ajánlat foglalássá alakítása",
    "delete_offer": "Ajánlat visszavonása",
    "delete_offer_confirmation": "Biztosan visszavonod az ajánlatot?",
    "offer_deleted": "Az ajánlat sikeresen visszavonásra került",
    "transform_successful": "Az ajánlat sikeresen foglalássá lett alakítva",
    "edit_existing_offer": "Meglévő ajánlat szerkesztése",
    "request_excluded": "Az ajánlatkérés sikeresen kizárásra került",
    "not_enabled": "A csoportos foglalás funkció nincs engedélyezve ehhez az étteremhez.",
    "form_validation_error": "Egy vagy több mező hibásan lett megadva. Kérlek ellenőrizd a mezőket és próbáld újra.",
    "order": {
        "event_date_asc": "Esemény dátuma",
        "event_date_desc": "Esemény dátuma",
        "created_at_asc": "Létrehozás",
        "created_at_desc": "Létrehozás",
        "deadline_asc": "Határidő",
        "deadline_desc": "Határidő"
    },
    "search_placeholder": "Keresés...",
    "file_too_large": "Egy fájl mérete maximum 7 MB lehet!",
    "files_too_large_total": "A fájlok összmérete maximum 20 MB lehet!",
    "attach_files": "Fájl(ok) csatolása:",
    "selected_files": "Kiválasztott fájlok:",
    "uploaded_files": "Feltöltött fájlok:",
    "notification_default": "Köszönjük érdeklődését, sajnos az ajánlatot nem tudjuk teljesíteni.",
    "notification_sent": "Értesítés elküldve a vendégnek.",
    "notification_error": "Nem sikerült elküldeni az értesítést.",
    "no_data": "Nincs megjeleníthető adat.",
    "loading": "Betöltés...",
    "actions": "Műveletek",
    "statuses": {
        "PENDING": "Függőben",
        "ACCEPTED": "Elfogadva",
        "DECLINED": "Elutasítva",
        "EXPIRED": "Lejárt"
    },
    "status_detail": {
        "NEW": "Új ajánlatkérés",
        "IN_PROGRESS": "Egyeztetés alatt",
        "SENT": "Ajánlat elküldve, visszajelzésre vár",
        "CONTRACT": "Szerződéskötés alatt",
        "CONTRACT_SIGNED": "Szerződés aláírva",
        "DEPOSIT_PAID": "Előleg fizetve",
        "PAID": "Teljesen kifizetve",
        "EVENT_DONE": "Lezárva, Rendezvény Megtartva",
        "DECLINED": "Ajánlat elutasítva",
        "FAILED": "Lezárva, Sikertelen/Rendezvény elmaradt"
    },
    "notify_customer_about_changes_via_email": "Küldjünk e-mailt a vendégnek az új / módosított ajánlatról?",
    "offer_status": "Ajánlat állapota",
    "no_offer_yet": "Még nincs ajánlat",
    "request_updated": "Az ajánlatkérés sikeresen frissítve lett",
    "request_update_failed": "Az ajánlatkérés frissítése nem sikerült",
    "fetch_request_error": "Az ajánlatkérés betöltése nem sikerült",
}

export default groupReservation;